import type { MoneyMapAccountWithAccountDetails } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useGetMembershipMoneyMapAccounts = requestBuilder.query<
    MoneyMapAccountWithAccountDetails[],
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/money-map/account/membership/${membershipId}`,
    queryKey: ({ membershipId }) =>
        `getMembershipMoneyMapAccounts/${membershipId}`,
});
